import React, { useEffect, useState } from 'react'
import { getLatestUploads } from '../apis/youtube'
import Video from './Video'
import { setVideosToFirestore } from '../apis/firebase'

export default function SyncVideos() {
  
  const [videos , setVideos] = useState([])
  const [selectedVideos, setSelectedVideos] = useState([])

  const SyncVideos = async () => {
    await setVideosToFirestore(selectedVideos)
    setSelectedVideos([])

  }

  useEffect(() => {
    const fetchVideos = async () => {
      
     const videos = await getLatestUploads()
     setVideos(videos)

     console.log(videos)
    
    }
    fetchVideos()

  } , [])

  useEffect(() => {
    
    console.log(selectedVideos)
  }, [selectedVideos])


  const handleSelectInput = (video) => {
    if (selectedVideos.length >= 6) return
    if (selectedVideos.findIndex(v => v.id.videoId === video.id.videoId) !== -1) return
    setSelectedVideos([...selectedVideos, video])
  }


  return (
    <div>
      <h1 className='yellowtext'>Videos to sync</h1>
      <div className='row'>
        { selectedVideos.length > 0 && selectedVideos.map((video) => (
         <div className='col m4 s12' onClick={() => setSelectedVideos(selectedVideos.filter(v => v.id.videoId !== video.id.videoId))} key={video.id.videoId}>
          <Video video={video}/>
          </div> 
        ))}

        
        </div>
        { selectedVideos.length === 6 && <button className='yellowbtn' onClick={SyncVideos}>Sync videos</button>}
      <h1 className='yellowtext'>Videos fetched from YouTube</h1>
      <div className='row'>
        { videos.length > 0 && videos.map((video) => (
         <div className='col m4 s12' onClick={() => handleSelectInput(video)} key={video.id.videoId}>
          <Video video={video}/>
          </div> 
        ))}
      </div>
      
    </div>
  )
}
